module.exports = __webpack_public_path__ + "static/img/ic_shenping.50e0c422.png";